const translations = {
  "en": {
    "Access to Edgen 360° Reports": "Access to Ed 360° Reports",
    "Extra Aura": "Extra Points",
    "More searches": "More searches",
    "Powerful trading tools": "Powerful trading tools"
  },
  "zh-tw": {
    "Access to Edgen 360° Reports": "存取 Ed 360° 報告",
    "Extra Aura": "額外 Points",
    "More searches": "更多搜尋",
    "Powerful trading tools": "強大的交易工具"
  }
};

export default translations;
